import { render } from "./analytical-dimensions-modal.vue?vue&type=template&id=f3153776"
import script from "./analytical-dimensions-modal.vue?vue&type=script&lang=js"
export * from "./analytical-dimensions-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__